var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex flex-column h-100",
      attrs: { elevation: "0", outlined: "", "min-height": "350" },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "py-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
          staticStyle: { "flex-wrap": "nowrap" },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center",
              staticStyle: { flex: "1 1 auto", "min-width": "0" },
            },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "white", medium: "" } },
                [_vm._v("flare")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                },
                [_vm._v(_vm._s(_vm.$t("scoutingAnalysis.scoutingAnalyses")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "pl-0 pr-0",
              staticStyle: { "flex-shrink": "0" },
              attrs: { text: "", small: "", to: `/library` },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "white--text text-decoration-underline font-weight-bold",
                },
                [_vm._v(_vm._s(_vm.$t("library.goToLibrary")))]
              ),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticClass: "ml-1", attrs: { small: "", color: "white" } },
                [_vm._v("keyboard_arrow_right")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          staticClass: "d-flex flex-column pb-1 overflow-auto flex-grow-1",
          staticStyle: { "padding-top": "0px !important" },
        },
        [
          !_vm.loading
            ? [
                _c("v-data-table", {
                  attrs: {
                    dense: "",
                    "disable-items-per-page": "",
                    "multi-sort": "",
                    headers: _vm.headers,
                    items: _vm.analyses,
                    "footer-props": {
                      itemsPerPageOptions: _vm.$vuetify.breakpoint.smAndDown
                        ? [1]
                        : [8],
                    },
                    "sort-by": "tsUpdated",
                    "sort-desc": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.playerId",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/player/${item.playerId}/scouting-analysis`,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(item.playerName))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.age",
                        fn: function ({ item }) {
                          return [
                            item.age
                              ? _c("span", { staticClass: "body-1" }, [
                                  _vm._v(_vm._s(item.age)),
                                ])
                              : _c("span", { staticClass: "body-1" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "item.fieldPositionId",
                        fn: function ({ item }) {
                          return [
                            item.fieldPositionId
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "monospace-font",
                                    attrs: {
                                      small: "",
                                      color: _vm.getPositionChipColor(
                                        item.fieldPositionId
                                      ),
                                      "text-color": "white",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getPositionCodeText(
                                            item.fieldPositionId
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "body-1" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "item.teamId",
                        fn: function ({ item }) {
                          return [
                            item.teamId
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center",
                                    attrs: { to: `/team/${item.teamId}` },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        height: "20px",
                                        width: "20px",
                                      },
                                      attrs: {
                                        src:
                                          "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                          item.teamId +
                                          ".png",
                                      },
                                      on: {
                                        error: function ($event) {
                                          return _vm.onImageLoadFailure($event)
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _c("span", { staticClass: "body-1" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "item.finalRating",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "ma-0 py-1" },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "monospace-font",
                                    attrs: {
                                      small: "",
                                      color: _vm.getRankingColor(
                                        item.finalRating
                                      ),
                                      "text-color": "white",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.finalRating))]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.recommendationId",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-ellipsis body-2 monospace-font",
                              },
                              [_vm._v(_vm._s(item.recommendation.text))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.createdById",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "span",
                              { staticClass: "text-ellipsis body-1" },
                              [_vm._v(_vm._s(item.createdByName))]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1082569912
                  ),
                }),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "30%" },
                    }),
                    _vm._v(" "),
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "15%" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(4, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }